"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgBoxOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M11 7.994H4v11.99h16V7.993h-7V8c0 .667-.334 1-1 1-.666 0-1-.333-1-1v-.007.001zM11 4H5.5l-1 2H11V4zm2 0v2h6.5l-1-2H13zM2 6.995c0-.205.09-.458.267-.759L3.874 3c.266-.667.64-1 1.126-1h14c.486 0 .855.333 1.107.999l1.552 3.083c.227.396.341.7.341.912v12.99c0 1.306-.667 1.972-2 1.997-1.333.025-6.667.025-16 0-1.333 0-2-.666-2-1.998V6.994v.001zM7 16h6c.667 0 1 .333 1 1 0 .665-.333.998-1 .998H7c-.667 0-1-.333-1-.999 0-.666.333-.999 1-.999zm0-4h3c.667 0 1 .333 1 1 0 .665-.333.998-1 .998H7c-.667 0-1-.333-1-.999 0-.666.333-.999 1-.999z' }))); };
exports.default = SvgBoxOutline;
//# sourceMappingURL=BoxOutline.js.map